const buildOperatorOptionsFromCandidate = (candidate) => {
  if (!candidate) {
    return [];
  }

  return [...candidate.analysis.rawOperatorTokensBySlug.values()].map((rawOperatorTokens) => {
    const rawOperatorToken = [...rawOperatorTokens][0];

    return {
      label: rawOperatorToken,
      shorthand: rawOperatorToken,
      value: rawOperatorToken
    };
  });
};

export default buildOperatorOptionsFromCandidate;
